import { Link } from "react-router-dom";

export function Pilots() {
  return (
    <div className="max-w-2xl">
      <span className="font-display text-xs font-semibold tracking-[0.18em] text-interceptor-500 uppercase">
        Interceptor
      </span>
      <h1 className="mt-2 font-display text-3xl font-semibold text-white">Pilots</h1>
      <p className="mt-4 text-base leading-relaxed text-void-400">
        Interceptor pilot creation is not open yet. It reuses the same engine as the Leviathan
        module, so it follows once Captains is finished and the pilot rules are written up.
      </p>
      <Link
        to="/captains"
        className="mt-8 inline-block text-sm font-medium text-leviathan-500 transition-colors hover:text-leviathan-600"
      >
        Build a Leviathan captain instead →
      </Link>
    </div>
  );
}
